const storename = () => {
  const str = window.location.hostname
  const store = str.split(".")
  return  store[0];
}


export default storename;
